import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { isDCompanySearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';


const mapFilterData = (data: IDCompanySearchForm): IDCompanySearchPost | {} => {
  if (isDCompanySearchFormEmpty(data) || data == undefined) { return {} };
  const removedUnusedFilters = filterNonEmptyValues(data);
  return removedUnusedFilters;
}

const getAllDCompanies = async ( {data} : {data: IDCompanySearchForm}): Promise<IGetDCompany> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;
  const response =  await axiosDefaultApi.post(`api/Search/Search/DCompanies?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData);
  return response as unknown as IGetDCompany;
};

type QueryFnType = typeof getAllDCompanies;

type UseGetAllDCompaniesOptions = {
  data: IDCompanySearchForm;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllDCompanies = ({ data, config }: UseGetAllDCompaniesOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllDCompanies'],
    queryFn: () => getAllDCompanies({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των Θυγατρικών.`, 500);
      setIsNotificationVisible(true);
      console.log(error);
    }
  });
};